import { Component, OnInit, OnDestroy } from '@angular/core';
import {Router, ActivatedRoute, NavigationEnd} from '@angular/router';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { AuthService } from "../auth.service";
import { UtilsService } from "../shared/shared.module";

import * as _ from "lodash";

declare let swal:any;

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {

  environment: any;
  errors = {};
  isLoading;
  message: string = null;

  user  = {
    password: '',
    confirm_password: '',
    email: null,
    reset: null,
  };

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private utilsService: UtilsService,
  ) { }

  ngOnInit() {
    this.isLoading = false;
    this.environment = environment;

    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      this.utilsService.scrollTop();
    });

    this.route.params.subscribe(params => {
      this.user.reset = params['reset'];
      this.user.email = params['email'];

      if (this.user.reset && this.user.email) {
        this.isLoading = true;
        this.http.get(environment.API_PATH + '/user/check-reset-code/' + this.user.email + '/reset/' + this.user.reset)
			  .subscribe(
          res => {
            this.isLoading = false;
            this.message = null;
          },
          err => {
            this.isLoading = false;
            this.message = "Il semblerait que ce lien ne soit plus valide";
          });
      }
      else
        this.message = "Il semblerait que ce lien ne soit plus valide";
    });
  }

  valueChange(field) {
    this.errors = {};
  }

  submitForm(form) {
    this.errors = {};
    if (form.invalid)
      return;

    let data = this.user;
    this.isLoading = true;

    this.http.post(environment.API_PATH + '/user/forgot/set-password', data, {withCredentials: true})
	  .subscribe(response => {
      this.isLoading = false;

      this.utilsService.displayNotif("Votre mot de passe a bien été modifié", "success");
      this.router.navigate(['/connexion']);
    }, err => {
      this.isLoading = false;
      if (err.status === 404) {
        var details = err.error.error.details;
        if (details === 'Password don\'t match')
          this.errors['password']= "Les mot de passe ne correspondent pas";
        else if (details === 'Password is missing')
          this.errors['password']= "Ce champ doit être rempli";
        else if (details === 'Confirm_password is missing')
          this.errors['confirm_password']= "Ce champ doit être rempli";
        else if (details === 'Password and confirm_password is missing') {
          this.errors['password']= "Ce champ doit être rempli";
          this.errors['confirm_password']= "Ce champ doit être rempli";
        }
      }
      else if (err.status === 400) {
        this.message = "Il semblerait que ce lien ne soit plus valide";
      }
      else {
        this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/forgot-password/forgot-password.component.ts